import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WhatsAppContactType } from "@packages/chat-sdk";

export interface WhatsAppChatPersistentStoreType {
  fromUserId?: string;
  toUserId?: string;
  chatId?: string;
  chatType?: WhatsAppContactType;
}
export const whatsappChatPersistentStore =
  new Store<WhatsAppChatPersistentStoreType>(
    persist(
      () => ({
        fromUserId: undefined,
        toUserId: undefined,
        chatId: undefined,
        chatType: undefined,
      }),
      {
        name: storageKey.WHATSAPP_CHAT_STORAGE, // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    ) as any
  );

export const whatsappChatPersistentStoreActions = {
  selectConversation(payload: {
    fromUserId?: string;
    toUserId?: string;
    chatId?: string;
    chatType?: WhatsAppContactType;
  }) {
    whatsappChatPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.WHATSAPP_CHAT_STORAGE);
  },
};
